/**
 * Set A «Ночной стадион»: colours, faces and sizes copied from the approved mockup
 * (`.claude/docs/match-video/video-sets-spec.html`, classes `.a-*`). Coordinates are the 1920×1080 frame.
 */
export const NIGHT = {
  bgInner: '#1d2a52',
  bgOuter: '#0b1020',
  lime: '#d4ff3a',
  orange: '#ff7a1a',
  champ: '#c9d2ea',
  foot: '#8e9abb',
  white: '#ffffff',
  ink: '#0b1020',
  bodyEnd: '#16213f',
  plateTeam: '#9fb0d8',
  minuteRule: '#2c3a66',
  dangerText: '#dfe5f5',
} as const;

/** The lime / orange / black of the set with an alpha — rings, the beam, pulses, drop shadows. */
export const limeAlpha = (alpha: number) => `rgba(212,255,58,${alpha})`;
export const orangeAlpha = (alpha: number) => `rgba(255,122,26,${alpha})`;
export const shadowAlpha = (alpha: number) => `rgba(0,0,0,${alpha})`;
export const whiteAlpha = (alpha: number) => `rgba(255,255,255,${alpha})`;

export const NIGHT_FONTS = {
  org: (px: number) => `800 ${px}px Unbounded`,
  champ: (px: number) => `600 ${px}px Inter`,
  round: (px: number) => `800 ${px}px Unbounded`,
  teamName: (px: number) => `700 ${px}px Unbounded`,
  score: (px: number) => `900 ${px}px Unbounded`,
  foot: (px: number) => `500 ${px}px Inter`,
  tag: (px: number) => `900 ${px}px Unbounded`,
  number: (px: number) => `900 ${px}px Unbounded`,
  player: (px: number) => `700 ${px}px Unbounded`,
  plateTeam: (px: number) => `500 ${px}px Inter`,
  minute: (px: number) => `800 ${px}px Unbounded`,
  danger: (px: number) => `600 ${px}px Inter`,
} as const;

/** Every face the set draws with — loaded before the first frame. */
export const NIGHT_FONT_FACES: readonly string[] = [
  NIGHT_FONTS.org(26),
  NIGHT_FONTS.champ(34),
  NIGHT_FONTS.teamName(44),
  NIGHT_FONTS.score(150),
  NIGHT_FONTS.foot(30),
];

/** Grid of the score row: the colon sits on the frame centre, numbers keep this gap from it. */
export const SCORE_GAP = 28;
export const FRAME_CENTER_X = 960;

/** Frame margins of the plates (`.a-plate`: left 96, bottom 80) — the right one mirrors the left. */
export const PLATE_LEFT = 96;
export const PLATE_BOTTOM = 80;
